export default "__VITE_ASSET__DetW0zhM__"